import React from "react";
import RequireRole from "./RequireRole";

export default function AdminGuard({ children }) {
  return <RequireRole roles={["admin", "superadmin"]}>{children}</RequireRole>;
}

